import { ModelFactory } from '@shared/factories/model.factory';
import { CountryType } from '@generated/graphql';
import { Country } from '@modules/country/models/country.model';

export class CountryFactory extends ModelFactory<CountryType, Country> {
  create (state: CountryType): Country {
    return new Country(state);
  }
}

export const countryFactory = new CountryFactory();
